<template>
    <v-flex></v-flex>
</template>

<script>
    export default {
        name: "RedirectURL",
        data() {
            return {
                url: '',
            }
        },
        created(){
            this.url =  this.$route.params.url;
        },
        mounted(){
            if(this.$route.params.url){
                window.open(this.$route.params.url);
                window.history.back();
            }

        }
    }
</script>

<style scoped>

</style>